import MyTableBtn from './tableBtn.vue';

MyTableBtn.install = function(Vue){
  Vue.component('MyTableBtn', MyTableBtn);
};

export default MyTableBtn;